import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { inject, observer } from 'mobx-react';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import MenuItem from '@material-ui/core/MenuItem';
import './AuthVerify.css';
import { setDigitalData } from '../../Utilities/Utils.js';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#3CB6CE",
            main: "#3CB6CE",
            dark: "#3CB6CE",
            contrastText: "#3CB6CE"
        },
        text: {
            primary:"white" ,
            secondary: "white"
        },
        action: {
            active:"white"
        }
    },
    typography : {
        fontFamily: ['Roboto Condensed','Roboto','Helvetica'].join(','),
        fontSize: "20",
    }
});

const styles = {
    resize:{
    },
    labelResize:{
    },
    menuItem:{
        color:'black',
    },
    underline: {
        color: theme.palette.common.white,
        borderBottom: theme.palette.common.white,
        '&:after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:focused::after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:before': {
            borderBottom: `1px solid ${theme.palette.common.white}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '2px solid rgb(255, 255, 255) !important',
        },
        '&$disabled:before': {
            borderBottom: `1px dotted ${theme.palette.common.white}`,
        },
    },
    disabled: {},
    focused: {},
    error: {}
}

class DGRAuthVerify extends Component {

    componentDidMount() {
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.errors = null;
        if ( !this.props.DGRStore.values.member_number ) {
            return this.props.history.push('');
        }
        setDigitalData( 'auth verify', this.props.DGRStore.club_number );
    }

    handleChange = (e) => {
        this.props.DGRStore.setValue( e.target.name, e.target.value );
    }

    // When searching by first name, last name, and birthday.
    handleSubmitVerifyAccount = (e) => {

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Member Login',
            action: 'Verify Information Form'
        });

        this.props.history.push( '/auth/create' );
    }

    render(){
        const { classes } = this.props;
        const { first_name, last_name, address1, address2, city, state, zipcode, phone } = this.props.DGRStore.values;

        const states = this.props.DGRStore.states.map( (state, i ) => {
            return ( 
                <MenuItem
                    classes={{
                        root: classes.menuItem 
                      }}

                    key={state} 
                    value={state}>
                        {state}
                    </MenuItem>
            ); 
        })

        return(
            <Fade>
            <div className="authVerify">
                <MuiThemeProvider theme={theme}>

                <div className="dgrTitleText">
                    <h2>Create New Account</h2>
                </div>

                <div className="dgrTitleSubText">
                    <div className="subText">
                        Setup online access to your membership account in three easy steps.
                    </div>
                </div>

                <div className="loginItems">  
                    <ValidatorForm
                        className="authVerifyForm"
                        ref="form"
                        autoComplete="off"
                        instantValidate={ false }
                        onSubmit={ this.handleSubmitVerifyAccount }
                        onError={ errors => console.log(errors) }
                    >

                        <h3>Step 2: Verify Your Information</h3>

                        <div className="row disabledRow">

                            <TextValidator
                                autoComplete="off"
                                disabled={ true }
                                label="First Name"
                                name="first_name"
                                id="firstNameField"
                                value={ first_name }
                                className="inputFieldColumn"
                                placeholder="eg: John"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }} />
                            <TextValidator
                                autoComplete="off"
                                disabled={ true }
                                label="Last Name"
                                name="last_name"
                                id="lastNameField"
                                className="inputFieldColumn"
                                value={ last_name }
                                placeholder="eg: Smith"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }} />

                        </div>
                        <div className="row">

                            <TextValidator
                                autoComplete="off"
                                label="Address 1"
                                onChange={this.handleChange}
                                name="address1"
                                id="address1Field"
                                value={ address1 }
                                validators={['required']}
                                errorMessages={['This field is required']}
                                className="inputFieldColumn"
                                placeholder="eg: 123 Drive Ln"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }} />
                            <TextValidator
                                autoComplete="off"
                                label="Address 2"
                                onChange={this.handleChange}
                                name="address2"
                                id="address2Field"
                                className="inputFieldColumn"
                                value={ address2 }
                                placeholder="eg: Apt. 1138"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }} />

                        </div>
                        <div className="row">

                            <TextValidator
                                autoComplete="off"
                                label="City"
                                onChange={this.handleChange}
                                name="city"
                                id="cityField"
                                value={ city }
                                validators={['required']}
                                errorMessages={['This field is required']}
                                className="inputFieldColumn"
                                placeholder="eg: Springfield"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }} />

                            <SelectValidator
                                autoComplete="off"
                                label="State"
                                onChange={this.handleChange}
                                name="state"
                                className="inputFieldSmall"
                                value={ state }
                                InputProps={{
                                    classes: {
                                        underline: classes.underline
                                    },
                                    name: 'state',
                                    id: 'stateField',
                                }}
                            >
                                { states }
                            </SelectValidator>

                            <TextValidator
                                autoComplete="off"
                                label="Zip"
                                onChange={this.handleChange}
                                name="zipcode"
                                id="zipcodeField"
                                className="inputFieldSmall"
                                value={ zipcode }
                                validators={['required','matchRegexp:^[0-9]{5}(-[0-9]{4})?$']}
                                errorMessages={['This field is required', 'Enter a valid US zipcode'  ]}
                                placeholder="eg: 12345"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }}
                            />

                        </div>
                        <div className="row">

                            <TextValidator
                                autoComplete="off"
                                label="Phone"
                                onChange={this.handleChange}
                                name="phone"
                                id="phoneField"
                                className="inputFieldColumn"
                                value={ phone }
                                validators={['required','matchRegexp:^\\D?(\\d{3})\\D?\\D?(\\d{3})\\D?(\\d{4})$']}
                                errorMessages={['This field is required', 'Enter a valid 10-digit phone number' ]}
                                placeholder="eg: 123-456-3828"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                        underline: classes.underline
                                    },
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.labelResize,
                                    },
                                }}
                            />

                        </div>

                        <div className="row">
                            <div className="continueBtn">
                                <button className="bigButton" type="submit">Next</button>
                            </div>
                        </div>

                    </ValidatorForm>

                </div>
                </MuiThemeProvider>
            </div>
            </Fade>
        )
    }
}

DGRAuthVerify = inject('DGRBackgroundStore','DGRStore')( observer( DGRAuthVerify ) )

export default withStyles( styles )( DGRAuthVerify );



// WEBPACK FOOTER //
// ./src/components/DGR/AuthVerify/AuthVerify.js